import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import MaterialsHero from './components/MaterialsHero';
import MaterialsGrid from './components/MaterialsGrid';
import MaterialDetails from './components/MaterialDetails';
import Footer from '../homepage/components/Footer';

const Materials = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Catálogo de Materiais - PH Móveis Artesanais",
    "description": "Explore nosso catálogo completo de materiais: tecidos premium, tecidos básicos, cordas, fibras, madeiras e muito mais.",
    "url": "https://phmoveis.com.br/materials",
    "mainEntity": {
      "@type": "ItemList",
      "name": "Catálogo de Materiais",
      "description": "Todos os materiais disponíveis para personalização de móveis artesanais",
      "itemListElement": [
        {
          "@type": "Product",
          "name": "Tecidos Premium",
          "description": "Tecidos de alta qualidade para acabamentos sofisticados"
        },
        {
          "@type": "Product",
          "name": "Tecidos Básicos",
          "description": "Tecidos clássicos para diferentes estilos de decoração"
        },
        {
          "@type": "Product",
          "name": "Cordas",
          "description": "Cordas naturais em diversas cores para detalhes únicos"
        },
        {
          "@type": "Product",
          "name": "Fibras",
          "description": "Fibras naturais para texturas e acabamentos especiais"
        },
        {
          "@type": "Product",
          "name": "Madeiras",
          "description": "Madeiras nobres brasileiras para estruturas resistentes"
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Catálogo de Materiais | PH Móveis Artesanais"
        description="Explore nosso catálogo completo de materiais: tecidos premium, tecidos básicos, cordas, fibras, madeiras e muito mais para personalizar seus móveis."
        keywords="catálogo materiais, tecidos premium, tecidos básicos, cordas, fibras, madeiras, personalização móveis, PH Móveis"
        image="https://phmoveis.com.br/assets/materials-catalog-og.jpg"
        url="https://phmoveis.com.br/materials"
        type="website"
        structuredData={structuredData}
      />
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <MaterialsHero />
          <MaterialsGrid />
          <MaterialDetails />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Materials;

